/**
 * Alert with human readable error messages
 *
 * TMT currently seems to use error messages like these
 * https://peachpayments.zendesk.com/hc/en-us/articles/200694456-Available-Return-Codes-000-000-000-to-999-999-999-
 */
export function tmtErrorAlert({
  content,
  setError,
}: { content?: string; setError?: (error?: string) => void } = {}): void {
  // CVV
  if (content.includes('invalid CVV')) {
    setError(
      'Sorry, your payment was declined due to an invalid CVV (card security code). Please try again.',
    );
  }

  // Card number
  else if (content.includes('invalid cc number')) {
    setError(
      'Sorry, your payment was declined due to an incorrect card number. Please try again.',
    );
  }

  // Expiry date
  else if (content.includes('wrong expiry date')) {
    setError(
      'Sorry, your payment was declined due to an incorrect expiry date. Please try again.',
    );
  }

  // Limit
  else if (
    content.includes('limit exceeded') ||
    content.includes('Insufficient Funds') ||
    content.includes('amount exceeds credit')
  ) {
    setError(
      'Sorry, the payment is greater than the current limit on your card. Please contact your bank to approve the amount, and then try again. Alternatively you can try a different card.',
    );
  }

  // Blocked
  else if (
    content.includes('card blocked') ||
    content.includes('Account Blocked') ||
    content.includes('stolen card') ||
    content.includes('Account Closed')
  ) {
    setError(
      'Sorry, your bank has blocked or disabled your card. Please contact them, or try with a different card.',
    );
  }

  // risk management transaction timeout
  else if (content.includes('risk management transaction timeout')) {
    setError(
      'Sorry, the 3D Secure process (where your bank texts you a code to confirm the payment) failed. Please try again, or alternatively try with a different card.',
    );
  }

  // Default
  else {
    setError('Payment declined - please try again.');
  }
}
